export default {
  computed: {
    /**
     * Displays the number of items going to in the 'showing' section next to pagination.
     */
    showingTo () {
      let to = this.currentPage * this.perPage

      if (to > this.totalRows) {
        return this.totalRows
      }

      return to
    }
  }
}
